import React from 'react';
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import './ProInfoForm.scss'
import Switch from 'react-switch'
import { Fire, Popup, Tools } from '../../services'

import { Input, Label } from 'reactstrap'
import { Headerbar, FormInput, DocumentPicker } from '../Reusable'

import FadeIn from 'react-fade-in';
import ProValidator from '../Admin/Pros/ProValidator'

interface Props {
  title: string;
  pro: any;
  disabled?: boolean;

  onSave: (info: any) => void;
}
const ProInfoForm: React.FC<Props> = (props) => {

  const [loading, setLoading] = React.useState(false)
  const [changed, setChanged] = React.useState(false)
  const [errors, setErrors] = React.useState<any>({})

  const [info, setInfo] = React.useState<any>(props.pro)

  React.useEffect(() => {
    setErrors(ProValidator.getAccountErrors(info))
  }, [info])

  const onChangePicture = async (key: string, event: any) => {
    try {
      const url = await Tools.requestSmallImage(event)
      onChange(key, { url: url, saved: false })
    } catch (err) {
      alert(err.message)
    }
  }

  const onChange = (key: string, value: any) => {
    info[key] = value
    setInfo({ ...info })
    setChanged(true)  
  }

  const onSave = async () => {
    setLoading(true)
    try {
      await props.onSave(info)
      setInfo({...info})
      setChanged(false)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const wasRequired = (value: any) => {
    return value && value.length > 0
  }

  const canEdit = !props.disabled
  const nbErrors = Object.keys(errors).length
  const isValid = nbErrors === 0 || (nbErrors === 1 && errors.stripe)
  return (
    <React.Fragment>
      
      <div className="card">
        <div className="card-header">
          <div className="row spaced-row">
            <h3 className="card-title">{props.title}</h3>
            { isValid ? (
              <span className="text-success">Complet <i style={{marginLeft: 10}} className="fa fa-check"></i></span>
            ) : (
              <span className="text-warning">Incomplet</span> 
            )}
          </div>
        </div>
        <div className="card-body">
        
          <FormInput
            type="text"
            error={errors.name}
            placeholder="Nom de l'organisation"
            value={info.name}
            onChange={(evt: any) => onChange('name', evt.target.value)}
            disabled={!canEdit}
            />

          { info.type === 'asso' && (
            <FormInput
              disabled={!canEdit}
              type="text"
              error={errors.school}
              placeholder={"Nom de l'école"}
              value={info.school}
              onChange={(evt: any) => onChange('school', evt.target.value)}
              />
          )}

          <div className="lined-inputs">
            <FormInput
              disabled={!canEdit}
              error={errors.address}
              type="text"
              placeholder={"Adresse" + (info.type === 'asso' ? " de l'école" : '')}
              value={info.address}
              onChange={(evt: any) => onChange('address', evt.target.value)}
            />

            <div style={{display: 'flex', flexDirection: 'row'}}>
              <FormInput
                disabled={!canEdit}
                error={errors.city}
                placeholder="Ville"
                type="text"
                value={info.city}
                onChange={(evt: any) => onChange('city', evt.target.value)}
              />
              <FormInput
                disabled={!canEdit}
                error={errors.postal_code}
                placeholder="Code Postal"
                type="number"
                value={info.postal_code}
                onChange={(evt: any) => onChange('postal_code', evt.target.value)}
              />
            </div>
          </div>

          <FormInput
            disabled={!canEdit}
            type="text"
            error={errors.holder_name}
            placeholder="Nom et prénom du responsable légal"
            value={info.holder_name}
            onChange={(evt: any) => onChange('holder_name', evt.target.value)}
            />

          <FormInput
            disabled={!canEdit}
            type="text"
            error={errors.phone}
            placeholder="Numéro de téléphone"
            value={info.phone}
            onChange={(evt: any) => onChange('phone', evt.target.value)}
            />

          <FormInput
            disabled={!canEdit}
            type="text"
            error={errors.web}
            placeholder="Lien du site Web"
            value={info.web}
            onChange={(evt: any) => onChange('web', evt.target.value)}
            />

          <FormInput
            disabled={!canEdit}
            type="text"
            error={errors.email}
            placeholder="Adresse e-mail"
            value={info.email}
            onChange={(evt: any) => onChange('email', evt.target.value)}
            />

          { canEdit &&
            <div className="input-wrapper" style={{paddingLeft: 20, marginBottom: 12}}>
              {errors.accepted ? (
                <div className="input-error">{errors.accepted}</div>
              ) : null}
              <Input
                type="checkbox"
                checked={info.accepted || false}
                disabled={!canEdit}
                onChange={(evt) => onChange('accepted', evt.target.checked)}
                />
              <div style={{display: 'inline-block'}}>Je certifie sur l'honneur, l'exactitude des informations ci-dessus.</div>
            </div>
          }

          <div className="settings-info">
            Ces infos resteront privées, utilisées uniquement afin de valider votre compte
          </div>

          { canEdit &&

            <div style={{marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={onSave}
                disabled={loading || !changed || !info.accepted}
                >
                { loading ? 'Chargement...' : 'Enregistrer' }
              </button>
              
            </div>
          }
        </div>
      </div>
    </React.Fragment>
  );
}

export default ProInfoForm